import React from 'react';
import Button from 'react-bootstrap/Button';
import './About.css';
import aboutImage from '../../image/about/1.jpg';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
const About = () => {
    return (
        <div>
            <div className="container my-5 pt-5">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <img src={aboutImage} alt="" />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 my-5 pt-5">
                        <Button variant="light" className="px-5 fw-bold fs-5">About</Button>
                        <div className="about-text my-3">
                            <h2 className="fw-bold text-left">Creative Independent Web Developer</h2>
                            <p>I'm web junior MERN Stack Developer, and I'm very passionate and dedicated to my work.I have acquired the skills and knowledge necessary to make your project a success. I enjoy every step of the design process, from discussion and collaboration</p>
                        </div>

                        <Button className="mx-3 mt-3 about-button" variant="info"> <a href="https://drive.google.com/uc?id=1gSQaR0Yogl85z0_WahWdU1pmiO8ZOPyq&export=download" target="_blank">Download Resume</a></Button>

                       

                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;